export default {
    /** Метод для запроса информации по платежу без сессии */
    getPaymentStatus(unp) {
        return this.jsonrpc('getPaymentStatus', [unp])
    }
}